import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';

const PIXEL_ID = '1405564765116112'; // Reemplaza con tu ID numérico de Meta

export default function PixelTracker() {
  const location = useLocation();

  // 1. Inicializar Pixel al montar la app
  useEffect(() => {
    const options = {
      autoConfig: true,
      debug: process.env.NODE_ENV !== 'production', // Muestra logs solo en desarrollo
    };
    ReactPixel.init(PIXEL_ID, undefined, options);
    ReactPixel.pageView();
  }, []);

  // 2. Disparar PageView cada vez que cambie la URL en react-router
  useEffect(() => {
    ReactPixel.pageView();
  }, [location]);

  return null; // No renderiza nada en el DOM
}